module.exports = __webpack_public_path__ + "static/media/reuters-logo.b67cea8a.png";